<div class="grid-y align-center align-middle no-content">
  <div class="cell">
    <img data-cy="noContentImage" src="assets/images/raven-bird.png" class="no-content__image" />
    <p>No Content to Display</p>
  </div>
</div>
